import React, { useState, useEffect, useRef } from 'react'
import {
  Row,
  Col,
  ListGroupItem,
  CustomInput,
  Input,
  Button,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
} from 'reactstrap';
import axios from 'axios'
import shortid from 'shortid'
import { Player, BigPlayButton } from 'video-react';
import 'video-react/dist/video-react.css'; // import css
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import UploadAudioDiv from './DemoUploadAudioDiv'
import * as MyAPI from '../../../utils/MyAPI'
import DemoEditor from './DemoEditor'
import soundwave from '../../../images/72459-sownd-wave.gif'

// DictMagicEditor
const DictMagicEditor = (props) => {

  // use refs
  let playerRef = useRef(null)
  let editorPositionRef = useRef(null)
  let editorRef = useRef();
  let widthRef = useRef(null)

  let [selectedFile, setSelectedFile] = useState(null);
  let [mediaUrl, setMediaUrl] = useState("")
  let [myBlob, setMyBlob] = useState(null)
  // let [videoExpandFlg, setVideoExpandFlg] = useState(false)
  let [isPlaying, setIsPlaying] = useState(false)
  let [transcriptDraftjsRaw, setTranscriptDraftjsRaw] = useState({
    blocks: [],
    entityMap: {},
  })
  let [transcribed, setTranscribed] = useState(false)

  let [playIconStopFlg, setPlayIconStopFlg] = useState(false)
  let [playIconStartTime, setPlayIconStartTime] = useState(0)
  let [playIconStartIndex, setPlayIconStartIndex] = useState(0)
  let [playIconStartTexts, setPlayIconStartTexts] = useState("")
  let [playIconStartDiff, setPlayIconStartDiff] = useState(null)

  // let [playIconEndTime, setPlayIconEndTime] = useState(5)
  let [playIconMarginTop, setPlayIconMarginTop] = useState(26)
  let [mojiokoCount, setMojiokoCount] = useState(0)

  let [blockTimes, setBlockTimes] = useState([])
  let [playingBlockIndex, setPlayingBlockIndex] = useState(0)
  let [playerCurrentTime, setPlayerCurrentTime] = useState(0)

  // handle selected file
  let _fileSlected = async (acceptedFiles) => {

    if (acceptedFiles.length !== 1) {
      props.showAlert("音声ファイルは一つずつアップロードして頂けますでしょうか。", "info")
      return
    }

    let _selectedFile = acceptedFiles[0]
    setSelectedFile(_selectedFile)

    let _tmp_path =  URL.createObjectURL(_selectedFile)
    setMediaUrl(_tmp_path)

    let blob = await fetch(_tmp_path).then(r => r.blob());
    setMyBlob(blob)
  }

  // convert blob into base64
  let _convertBlob2Base64 = (blob) => {

    return new Promise(function(resolve, reject) {

      var reader = new FileReader();
      reader.readAsArrayBuffer(blob)

      reader.onloadend = function() {
        var data = reader.result;
        let _buffer = new Buffer(data);
        resolve(_buffer.toString("base64"))
      }

    })
  }

  // send audio to api server directly...
  let _transcribe2 = async () => {

    // duration check
    const { player } = playerRef.current.getState();
    if ( player.duration < 10 ) {
      props.showAlert("音声が短過ぎます。音声は10秒以上、10分未満でお願いします。", "info")
      return
    } else if ( player.duration > 600 ) {
      props.showAlert("音声が長過ぎます。音声は10秒以上、10分未満でお願いします。", "info")
      return
    }

    props.setLoading(true)

    try {


      // dictinary is applied automatically
      let _mini_dict = []

      let api_key = ""
      let api_url = ""

      for ( let i=0; i<props.deepSpeechTokens.length; i++ ) {
        let _item = props.deepSpeechTokens[i]
        if (_item._id === props.apiIdSelected) {
          api_key = _item.api_key
          api_url = _item.api_url
          break
        }
      }

      if (!api_key || !api_url) {
        props.showAlert("api key not deteced.", "error")
        return;
      }

      // myBlob
      let base64 = await _convertBlob2Base64(myBlob)

      let results = await _transcribeBase64(api_key, api_url, base64, _mini_dict)

      // make draftjs

      let transcript_draftjs_raw = {
        blocks: [],
        entityMap: {},
      }

      if (results && results.length > 0) {
        // transcript = results[0].alternatives[0].transcript
        for (let i=0; i<results.length; i++) {

          let _transcript = results[i].alternatives[0].transcript
          let _startTime = results[i].alternatives[0].startTime
          let _endTime = results[i].alternatives[0].endTime

          if (_transcript) {

            let _key = shortid.generate()

            let _word_count = _transcript.trim().length

            transcript_draftjs_raw.blocks.push({
              depth:0,
              data: {
                'time0': _startTime+"~"+_endTime+"@0-"+_word_count,
              },
              entityRanges: [],
              inlineStyleRanges: [],
              key: _key,
              text: _transcript.trim(),
              type: "unstyled",
            })
          }
        }
      }

      // set transcript_draftjs_raw
      setTranscriptDraftjsRaw(transcript_draftjs_raw)

      // set transcribed true
      setTranscribed(true)

      props.showAlert("OK", "success")

    } catch (err) {
      console.log("err: ", err )

      props.showAlert(err.message, "error")
    }

    props.setLoading(false)
  }

  // transcribe local file
  const _transcribeBase64 = async (api_key, api_url, audio_base64, mini_dictionary) => {

    try {

      let results_1 = await axios.post(api_url, {
        audio: audio_base64,
        response_type: 'v2',
        stereo: false,
        get_timestamps: false,
        mini_dictionary: mini_dictionary,
      }, {
        headers: {
          'Accept': 'application/json',
          'Authorization': api_key,
        },
      })
      let _results_2 = null
      if (results_1.data) {
        _results_2 = results_1.data
      }

      if (_results_2.status !== 'success') {
        throw Error(_results_2.message)
      }

      let _results_3 = _results_2.results

      return _results_3

    } catch (err) {
      throw Error(err.message)
    }
  }

  // // pause media
  // let _togglePlayMedia = () => {
  //
  //   if (!playerRef || !playerRef.current) {
  //     return
  //   }
  //
  //   const { player } = playerRef.current.getState();
  //
  //   if ( player.paused !== false ) {
  //
  //     _playMedia({ start: playIconStartTime, end: playIconEndTime})
  //     setIsPlaying(true)
  //
  //   } else {
  //     playerRef.current.pause()
  //     setIsPlaying(false)
  //   }
  // }

  // pause media
  let _togglePlayMedia = () => {

    if (!playerRef || !playerRef.current) {
      return
    }

    const { player } = playerRef.current.getState();

    if ( player.paused !== false ) {

      _playMedia()
      setIsPlaying(true)

    } else {

      playerRef.current.pause()
      setIsPlaying(false)
    }
  }

  // play
  let _playMedia = () => {

    if (!playerRef || !playerRef.current) {
      return
    }
    if ( playerRef.current.paused === true ) {
      return
    }
    setIsPlaying(true)

    // get block times
    let _blockTimes = _prepareBlockTimes()

    let _blockTime = blockTimes[playIconStartIndex]

    // start time
    // let _start = _blockTime["start"]
    let _start = 0
    for (let i=0; i<blockTimes.length; i++) {
      let _blocktime = blockTimes[i]
      if (_blocktime.index >= playIconStartIndex) {
        _start = _blocktime.start
        break
      }
    }

    playerRef.current.seek(_start)
    playerRef.current.play()
  }

  // prepare block times
  let _prepareBlockTimes = () => {

    if (!editorRef.current) {
      return
    }

    let editor_width = 0
    if (editorRef.current) {
      editor_width = widthRef.current.offsetWidth
    } else {
      return
    }

    // get block timestamps
    let blocks =  editorRef.current.getBlocks()

    let _blockTimes = blockTimes

    for ( let i=0; i<blocks.length; i++ ) {
      let _item = blocks[i]

      // console.log("_item: ", _item)

      if (_item.data && _item.data.time0) {

        let time0 = _item.data.time0

        if ( time0.indexOf("dummy") === -1 ) {
          let time1 = time0.split("___")[0]
          let time2 = time1.split("@")[0]
          let start = parseFloat(time2.split("~")[0])
          let end = parseFloat(time2.split("~")[1])

          // calculate width
          let _span = document.createElement('span');
          _span.setAttribute("style", "font-size: 20px;");
          _span.innerText = _item.text
          document.body.appendChild(_span);
          let _span_w = _span.getBoundingClientRect().width
          document.body.removeChild(_span);

          let line_count = Math.ceil(_span_w / editor_width)

          // let line_count = 1

          _blockTimes.push({
            text: _item.text,
            index: i,
            start: start,
            end: end,
            line_count: line_count,
          })
        }
      }
    }

    // set block timestamps ...
    setBlockTimes(_blockTimes)

    return _prepareBlockTimes
  }


  // react-video subscribe state change
  useEffect(() => {

    if (!playerRef.current) {
      return
    }

    let _blockTimes = blockTimes

    let _line_diff = 0

    for (let i=0; i<_blockTimes.length; i++) {
      let _item = _blockTimes[i]
      let _start = _item.start
      let _end = _item.end
      let _index = _item.index

      let _line_count = _item.line_count
      _line_diff = _line_diff + _line_count - 1

      if (playerCurrentTime > _start && playerCurrentTime < _end) {

        _index = _index + _line_diff

        setPlayingBlockIndex(_index)

        break
      }
    }

  }, [playerCurrentTime, playerRef.current]);


  // react-video subscribe state change
  let _handlePlayerStateChange = (state) => {
    // console.log("state.currentTime: ", state.currentTime)

    setPlayerCurrentTime(state.currentTime)

    if (isPlaying === true && state.paused === true) {

      setBlockTimes([])

      // console.log("dfasfs")
      setIsPlaying(false)

    } else if (isPlaying === false && state.paused === false) {

      if ( transcribed ===true && blockTimes.length === 0) {

        // get block times
        _prepareBlockTimes()
      }

      // console.log("_handlePlayerStateChange 1111 ", isPlaying)
      setIsPlaying(true)
    }
  }

  // react-video subscribe state change
  useEffect(() => {
      if (playerRef.current) {
          playerRef.current.subscribeToStateChange(_handlePlayerStateChange)
      }
  }, [_handlePlayerStateChange]);

  // add vocabs to custom dictionary
  let _addVocabsToCustomDictonary = async (draftjs_obj ) => {

    props.setLoading(true)

    try {

      // get evaluation masters
      const results_1 = await MyAPI.addVocabsToCustomDictonary({
        draftjs_obj: draftjs_obj,
        login_token: props.login_token,
        api_key_id: props.apiIdSelected,
      })
      if (results_1.status !== "success") {
        throw Error(results_1.message)
      }

      props.showAlert("辞書登録成功", "success")

      props.getVocabListAgain(props.apiIdSelected)

    } catch (err) {
      console.log("err: ", err )

      props.showAlert(err.message, "error")
    }

    props.setLoading(false)
  }

  // set ypos and start time
  let _setYPos = ({
    relativeY,
    texts,
  }) => {

    let domRect = editorPositionRef.current.getBoundingClientRect();

    let _margin = relativeY - domRect.top + 4

    setPlayIconMarginTop(_margin)

    let _index = parseInt(_margin / 30)

    setPlayIconStartIndex(_index)
    setPlayIconStartTexts(texts)
  }

  // _checkWord
  let _checkWord = async (fixed_words, fixed_list1) => {

    props.setLoading(true)

    try {

      // get evaluation masters
      const results_1 = await MyAPI.checkPotentialDictVocab({
        fixed_words: fixed_words,
        fixed_blocks: fixed_list1,
      })
      if (results_1.status !== "success") {
        throw Error(results_1.message)
      }

      props.setLoading(false)

      if (results_1.trimmed_words) {
        return results_1.trimmed_words
      }

    } catch (err) {
      console.log("err: ", err )

      props.showAlert(err.message, "error")

      props.setLoading(false)
    }
  }


  return (
    <div style={{
      fontSize: 20,
      marginBottom: 20,
    }}>

      {/* explain */}
      <Row style={{
        marginTop: 20,
        marginBottom: 20,
      }}>
        <Col md="2" xs="12" />

        <Col md="8" xs="12" styles={{
        }}>
          <span>
            カスタム辞書簡単作成エディタは実際の音声をドラッグ、文字起こし、修正を行うことで簡単にカスタム辞書を作成できるツールです。
            <br/>
            ※ 通常のAPI利用料が発生します
          </span>
        </Col>

        <Col md="2" xs="12" />
      </Row>

      {/* show selected file  */}
      <Row style={{
        marginTop: 20,
        marginBottom: 20,
      }}>
        <Col md="2" xs="12" />
        <Col md="4" xs="12">
        </Col>

        <Col md="4" xs="12" styles={{
          wordBreak: 'break-all',
        }}>
          {selectedFile && (
            <span>
              {selectedFile.name}
            </span>
          )}

        </Col>

        <Col md="2" xs="12" />
      </Row>


      {/* step 2 click recording button */}
      <Row style={{
        marginTop: 20,
        marginBottom: 20,
      }}>
        <Col md="3" xs="12" />
        <Col md="6" xs="12">
          <UploadAudioDiv fileSlected={_fileSlected} />
        </Col>
        <Col md="3" xs="12" />
      </Row>

      <Row style={{
        marginTop: 20,
        marginBottom: 20,
      }}>
        <Col md="3" xs="12" />
        <Col md="6" xs="12" style={{
          textAlign: 'center',
        }}>

        {mediaUrl && (
          <div style={{
            position: 'relative',
            width: '100%',
          }}>

            <Player
              onEnded={() => setIsPlaying(false)}
              ref={playerRef}
              poster={require("../../../images/editor_poster.png")}
              playsInline={true}
              src={mediaUrl} >
                <BigPlayButton position="center" />
            </Player>
          </div>
        )}

        </Col>
        <Col md="3" xs="12" />
      </Row>



      {/* step 4 edit transcript */}
      <Row style={{
        marginTop: 20,
        marginBottom: 20,
      }}>
        <Col md="2" xs="12" />

        <Col md="4" xs="12">

        </Col>

        <Col md="4" xs="12" style={{
          textAlign: 'right',
        }}>

          {myBlob !== null && (
            <img onClick={_transcribe2} src={require("../../../images/moji_btn.png")}
              style={{
                cursor: 'pointer',
                marginLeft: 16,
                marginRight: 16,
                height: 56,
            }} />

          )}

        </Col>
        <Col md="2" xs="12" />
      </Row>

      {/* calculate width */}
      <Row>
        <Col md="2" xs="12" />
        <Col md="8" xs="12">
          <div ref={widthRef} style={{
            width: '100%',
            height: 1,
          }} />
        </Col>
        <Col md="2" xs="12" />
      </Row>

      <Row style={{
        marginTop: 20,
        marginBottom: 20,
      }}>

        <Col md="1" xs="12" style={{
          textAlign: 'right',
        }}>
          {transcribed === true && isPlaying === true && (
            <img src={soundwave} style={{
              width: 60,
              height: 60,
              fontSize: 15,
              // cursor: 'pointer',
              marginLeft: 60,
              marginRight: 10,
              color: '#777777',
              marginTop: 4 + playingBlockIndex * 29,
            }} alt="soundwave" />
          )}

        </Col>

        <Col md="1" xs="12" style={{
          textAlign: 'right',
        }}>

          {transcribed === true  && (
            <FontAwesomeIcon
              onClick={() => _togglePlayMedia()}
              icon={isPlaying === true ? 'pause' : 'play'}
              style={{
                fontSize: 15,
                cursor: 'pointer',
                marginLeft: 10,
                marginRight: 10,
                color: '#777777',
                marginTop: playIconMarginTop,
            }}/>
          )}

        </Col>

        <Col md="8" xs="12">

        {/* draftjs editor and submit btn */}
        {myBlob !== null && (
          <DemoEditor
            ref={editorRef}
            addVocabsToCustomDictonary={_addVocabsToCustomDictonary}
            setYPos={_setYPos}
            showAlert={props.showAlert}
            mojiokoCount={mojiokoCount}
            checkWord={_checkWord}
            transcriptDraftjsRaw={transcriptDraftjsRaw} />
        )}

        </Col>
        <Col md="2" xs="12">
          <div ref={editorPositionRef} />
        </Col>
      </Row>

    </div>
  )
}
export default DictMagicEditor
